<div class="position-relative center">
    @if (useTextButtons == true) {
      @if (!videoStream) {
      <div class="button">
        <div class="button-label" (click)="fileInput.click()">
          Change image
        </div>
      </div>
      }
      @if (!videoStream && imageWasCaptured == false && showCaptureButton == true) {
        <div class="button">
        <div (click)="requestCameraPermissions()" type="button" class="button-label">
          @if (contentType != 'comment') {
            Camera
          }
        </div>
        </div>
      }
      @if (videoStream) {
        @if (isAudioRecording == false) {
        <div class="button">
        <div (click)="captureImage()" type="button" class="button-label">
          @if (contentType != 'comment') {
            Take photo
          }
        </div>
        </div>
        }
        @if (isVideoRecordingAllowed == true) {
        @if (isCameraRecording == false) {
          <div class="button">
        <div (click)="startRecording()" type="button" class="button-label">
          @if (contentType != 'comment') {
            Record video
          }
        </div>
        </div>
      } @else {
        <div class="button">
        <div (click)="stopRecording()" type="button" class="button-label">
          @if (contentType != 'comment') {
            Stop recording
          }
        </div>
        </div>
      }
    }
    @if (isAudioRecording == false) {
        <div class="button">
        <div (click)="stopVideoStream()" type="button" class="button-label">
          @if (contentType != 'comment') {
            Close camera
          }
        </div>
        </div>
      }
      }
    } @else {
      <div class="btn-group position-absolute corner m-1 minheight" >
        @if (!videoStream) {
        <button (click)="fileInput.click()" type="button" class="btn btn-sm btn-outline-secondary noborder" data-bs-toggle="tooltip" data-bs-placement="top" title="Upload file from your computer" data-bs-delay="{show: 1000}">
          <span class="mdi--tray-upload"></span>
        </button>
        }
      @if (!videoStream && imageWasCaptured == false && showCaptureButton == true) {
        <button (click)="requestCameraPermissions()" type="button" class="btn btn-sm btn-outline-secondary noborder" data-bs-toggle="tooltip" data-bs-placement="top" title="Tap to open camera" data-bs-delay="{show: 1000}">
          <span class="mdi--camera-outline"></span>
          @if (contentType != 'comment') {
            Camera
          }
        </button>
      }
      @if (videoStream) {
        @if (isAudioRecording == false) {
        <button (click)="captureImage()" type="button" class="btn btn-sm btn-outline-secondary " data-bs-toggle="tooltip" data-bs-placement="top" title="Tap to take picture" data-bs-delay="{show: 1000}">
          <span class="mdi--camera-outline"></span>
          @if (contentType != 'comment') {
            Take photo
          }
        </button>
      }
        @if (isVideoRecordingAllowed == true) {
        @if (isCameraRecording == false) {
        <button (click)="startRecording(false)" type="button" class="btn btn-sm btn-outline-secondary " data-bs-toggle="tooltip" data-bs-placement="top" title="Start recording" data-bs-delay="{show: 1000}">
          <span class="mdi--video-outline"></span>
          @if (contentType != 'comment') {
            Record video
          }
        </button>
        <button (click)="startRecording(true)" type="button" class="btn btn-sm btn-outline-secondary " data-bs-toggle="tooltip" data-bs-placement="top" title="Start recording" data-bs-delay="{show: 1000}">
          <img src="../../assets/microphone-2-svgrepo-com.svg" alt="Microphone" width="20" height="20">
          @if (contentType != 'comment') {
            Record audio
          }
        </button>
      } @else {
        <button (click)="stopRecording()" type="button" class="btn btn-sm btn-outline-secondary " data-bs-toggle="tooltip" data-bs-placement="top" title="Stop recording" data-bs-delay="{show: 1000}">
          <span class="mdi--video-off-outline"></span>
          @if (contentType != 'comment') {
            Stop recording
          }
        </button>
      }
    }
    @if (isAudioRecording == false) {
        <button (click)="stopVideoStream()" type="button" class="btn btn-sm btn-outline-secondary ">
          <span class="mdi--camera-off-outline"></span>
          @if (contentType != 'comment') {
            Close camera
          }
        </button>
      }
      }
    </div>
    }


  <input hidden (change)="selectFile($event)" #fileInput type="file" id="file"  [accept]="imageOnly ? 'image/*' : 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,presentation,text/csv,image/*,audio/*'"  multiple>
  @if (currentFileUpload) {
    <div >
      <div
        attr.aria-valuenow="{{ percentage }}"
        aria-valuemin="0"
        aria-valuemax="100"
        [ngStyle]="{ width: percentage + '%' }"
        >
        @if (percentage < 100) {
          <span>{{ percentage }}%</span>
        }
      </div>
    </div>
  }

  @if (videoStream && showCaptureButton == true) {
    @if (isAudioRecording == false) {
      <video #videoElement autoplay muted playsinline class="video-window"></video>
    }
  }

  @if (capturedImage && showCaptureButton == true) {
    <div class="video-window">
      <img [src]="capturedImage" alt="Captured Image" width="300">
    </div>
  }
  @if (errorMsg) {
    <div>
      <p>{{ errorMsg }}</p>
    </div>
  }
</div>